import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "./layout/AppLayout";
import { AuthLayout } from "./layout/AuthLayout";
import { LoginPage } from "@/features/auth/pages/LoginPage";
import { RegisterPage } from "@/features/auth/pages/RegisterPage";
import { ActivateAccountPage } from "@/features/auth/pages/ActivateAccountPage";
import { PendingStatusPage } from "@/features/auth/pages/PendingStatusPage";
import { OAuthCallbackPage } from "@/features/auth/pages/OAuthCallbackPage";
import { AgencyProfilePage } from "@/features/onboarding/pages/AgencyProfilePage";
import { TermsPage } from "@/features/onboarding/pages/TermsPage";
import { PendingApprovalPage } from "@/features/onboarding/pages/PendingApprovalPage";
import { DashboardPage } from "@/features/dashboard/pages/DashboardPage";
import { PropertiesPage } from "@/features/properties/pages/PropertiesPage";
import { LaunchesPage } from "@/features/launches/pages/LaunchesPage";
import { BrokersPage } from "@/features/brokers/pages/BrokersPage";
import { AgencyReportsPage } from "@/features/reports/pages/AgencyReportsPage";
import { SupportPage } from "@/features/support/pages/SupportPage";
import { TicketDetailPage } from "@/features/support/pages/TicketDetailPage";
import { NotificationsPage } from "@/features/notifications/pages/NotificationsPage";
import { AgencySettingsPage } from "@/features/settings/pages/AgencySettingsPage";

export const router = createBrowserRouter([
  // Public Routes (Auth)
  {
    element: <AuthLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/activate-account", element: <ActivateAccountPage /> },
      { path: "/pending", element: <PendingStatusPage /> },
    ],
  },

  // OAuth callback do login social (público — abre a sessão e roteia).
  { path: "/auth/callback/:provider", element: <OAuthCallbackPage /> },

  // Onboarding (autenticado, fora do AppLayout — cada página guarda a sessão).
  { path: "/onboarding/agency-profile", element: <AgencyProfilePage /> },
  { path: "/onboarding/terms", element: <TermsPage /> },
  { path: "/onboarding/pending", element: <PendingApprovalPage /> },

  // Protected Routes
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/brokers", element: <BrokersPage /> },
      { path: "/properties", element: <PropertiesPage /> },
      { path: "/launches", element: <LaunchesPage /> },
      { path: "/reports", element: <AgencyReportsPage /> },
      { path: "/support", element: <SupportPage /> },
      { path: "/support/:id", element: <TicketDetailPage /> },
      { path: "/notifications", element: <NotificationsPage /> },
      { path: "/settings", element: <AgencySettingsPage /> },
    ],
  },

  // Fallback
  { path: "*", element: <Navigate to="/dashboard" replace /> },
]);
